import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { EstimativaStaffPlanCronogramaMensal } from '../models/estimativa-staff-plan.model';

@Injectable({
    providedIn: 'root'
})

export class EstimativaStaffPlanCronogramaMensalService extends BaseService<EstimativaStaffPlanCronogramaMensal> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/EstimativaStaffPlanCronogramaMensal`, injector);
    }

    update(entity: EstimativaStaffPlanCronogramaMensal): Observable<EstimativaStaffPlanCronogramaMensal> {
        return this.http.put<EstimativaStaffPlanCronogramaMensal>(`${environment.API_PRICE}/EstimativaStaffPlanCronogramaMensal/Update`, entity);
    }
}